export const DummyRasterizer = ({ children }) => children;
//# sourceMappingURL=index.js.map